import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '@/shared/lib/cn';

const badgeVariants = cva(
  'inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-full border border-transparent font-bold whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3',
  {
    variants: {
      variant: {
        neutral: 'bg-muted text-foreground',
        primary: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        outline: 'border-border text-foreground',
        emphasis: 'bg-emphasis text-emphasis-foreground',
      },
      size: {
        default: 'px-2.5 py-0.5 text-xs',
        compact: 'px-2 py-0 text-xs',
      },
    },
    defaultVariants: { variant: 'neutral', size: 'default' },
  },
);

/** Small pill for counts, tags and categories. For a state (queued, failed…) use `StatusBadge`. */
function Badge({
  className,
  variant = 'neutral',
  size = 'default',
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return (
    <span
      data-slot="badge"
      data-variant={variant}
      data-size={size}
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
